import React, { useState } from "react";
import RecessImage from "../../../Assets/Images/recess-1.png";
import RecessImageTwo from "../../../Assets/Images/recess-2.png";
import RecessImageThree from "../../../Assets/Images/bd2.png";
import RecessImageFour from "../../../Assets/Images/bd1.png";
import FDServices from "../../../Assets/Images/fd-services-2.png";
import FDCarnival from "../../../Assets/Images/fd-carnival-updated.png";
import FDCarnivalPopup from "../../../Assets/Images/fd-carnival-popup.png";
import carnivalWeb from "../../../Assets/Images/carnival-banner.png";
import carnivalMobile from "../../../Assets/Images/carnival-banner-mobile.png";

import "./fde.css";
import { MEDIA_LINKS } from "../../../Constants/mediaLinks";
import ImagePopup from "../../ImagePopup";

export default function FDE() {
  const [openCarnivalImage, setOpenCarnivalImage] = useState(false);
  return (
    <>
      <div id="fde-recess" className="fde-recess">
        <img
          className="fde-carnival-web"
          src={carnivalWeb}
          alt="carnival_web"
        />
        <img
          className="fde-carnival-mobile"
          src={carnivalMobile}
          alt="carnival_mobile"
        />
        {/* <div id="fde-heading" className="fde-heading">
          <div className="fde-image-wrap">
            <img src={RecessImageFour} alt="recess" />
          </div>

          <h2 className="fde-title">
            Field Day Enhancements / Carnival Specials
          </h2>

          <div className="fde-image-wrap">
            <img src={RecessImageThree} alt="recess" />
          </div>
        </div> */}
      </div>

      <div id="fde-services-container" className="fde-services-container">
        {/* SERVICES SECTION */}
        <div className="fde-box">
          <div className="fde-box-header">
            <h2>Add additional services for your FIELD DAY!</h2>
          </div>

          <div className="fde-banner">
            <img src={FDServices} alt="services" />
          </div>

          <button
            onClick={() => {
              window.open(MEDIA_LINKS.FIELD_DAYS.ADDITIONAL_SERVICES, "_blank");
            }}
            className="fde-btn"
          >
            Learn More
          </button>
        </div>

        {/* CARNIVAL SECTION */}
        <div className="fde-box">
          <h2 style={{marginBottom: "20px", marginTop: "-40px"}}>Minimum of 4 Inflatables</h2>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => setOpenCarnivalImage(true)}
            className="fde-banner"
          >
            <img src={FDCarnival} alt="carnival" />
          </div>

          <button
            onClick={() => {
              window.open(MEDIA_LINKS.FIELD_DAYS.CARNIVAL_PRICE);
            }}
            className="fde-btn fde-btn-carnival"
          >
            Learn More
          </button>
          {openCarnivalImage && (
            <ImagePopup
              image={FDCarnivalPopup}
              onClose={() => setOpenCarnivalImage(false)}
            />
          )}
        </div>
      </div>
    </>
  );
}
